import { fromJS } from 'immutable';

const getChannelInfo = (state) => {
  const moduleName = 'axp-card-upgrade-united-states';
  const moduleState = state.getIn(
    ['modules', moduleName],
    fromJS({})
  ).toJS();
  /* istanbul ignore next */
  if (moduleState) {
    const postParams = moduleState && moduleState.req && moduleState.req.body;
    const isWebLogIn = postParams && postParams.channel ? postParams.channel.toLowerCase() : null;
    if (isWebLogIn === 'web') {
      return true;
    }
  }
  return false;
};

export default getChannelInfo;
